import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit'

export interface MotorbikePhoto {
  id: string
  position: number
  url: string | null
  thumb_url: string | null
}

export interface PhotosReducer {
  motorbikeId: string | null
  photos: MotorbikePhoto[]
  loading: boolean
  error: boolean
}

const initialState: PhotosReducer = {
  motorbikeId: null,
  photos: [],
  loading: false,
  error: false
}

export const FETCH_MOTORBIKE_PHOTOS = createAction<string>('photos_reducer/fetch_motorbike_photos')
export const FETCH_MOTORBIKE_PHOTOS_SUCCESS = createAction<{
  motorbikeId: string
  photos: MotorbikePhoto[]
}>('photos_reducer/fetch_motorbike_photos_success')
export const FETCH_MOTORBIKE_PHOTOS_FAILURE = createAction('photos_reducer/fetch_motorbike_photos_failure')

export const CREATE_MOTORBIKE_PHOTO = createAction<{
  motorbikeId: string
  file: string
}>('photos_reducer/create_motorbike_photo')
export const CREATE_MOTORBIKE_PHOTO_SUCCESS = createAction<MotorbikePhoto>(
  'photos_reducer/create_motorbike_photo_success'
)
export const CREATE_MOTORBIKE_PHOTO_FAILURE = createAction('photos_reducer/create_motorbike_photo_failure')

export const DELETE_MOTORBIKE_PHOTO = createAction<{
  motorbikeId: string
  photoId: string
}>('photos_reducer/delete_motorbike_photo')
export const DELETE_MOTORBIKE_PHOTO_SUCCESS = createAction<string>('photos_reducer/delete_motorbike_photo_success')
export const DELETE_MOTORBIKE_PHOTO_FAILURE = createAction('photos_reducer/delete_motorbike_photo_failure')

export const photosReducer = createReducer(initialState, (builder) => {
  builder.addCase(FETCH_MOTORBIKE_PHOTOS, (state, action) => {
    const sameMotorbike = state.motorbikeId === action.payload
    return {
      ...state,
      motorbikeId: action.payload,
      photos: sameMotorbike ? state.photos : [],
      loading: true,
      error: false
    }
  })
  builder.addCase(FETCH_MOTORBIKE_PHOTOS_SUCCESS, (state, action) => {
    return {
      ...state,
      motorbikeId: action.payload.motorbikeId,
      photos: action.payload.photos,
      loading: false,
      error: false
    }
  })
  builder.addCase(FETCH_MOTORBIKE_PHOTOS_FAILURE, (state) => {
    return { ...state, loading: false, error: true }
  })
  builder.addCase(CREATE_MOTORBIKE_PHOTO_SUCCESS, (state, action) => {
    return { ...state, photos: [...state.photos, action.payload], error: false }
  })
  builder.addCase(CREATE_MOTORBIKE_PHOTO_FAILURE, (state) => {
    return { ...state, error: true }
  })
  builder.addCase(DELETE_MOTORBIKE_PHOTO_SUCCESS, (state, action: PayloadAction<string>) => {
    return { ...state, photos: state.photos.filter((photo) => photo.id !== action.payload), error: false }
  })
  builder.addCase(DELETE_MOTORBIKE_PHOTO_FAILURE, (state) => {
    return { ...state, error: true }
  })
})
